
    (function ($) {

        $.fn.RampWrapper = function (options) {
            var $element = this;
            var defaults = { callback: function () { } };

            var settings = $.extend({}, defaults, options);

            if (settings.Ramp.SignalParam.series.length == 0) {

                $element.html($("<div>").addClass("note").html(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl)); 
                return true;
            }

           
            var h = $element.height()+5;
            var w = $element.width();



            var guid = Math.floor(Math.random() * 900000) + 100000;
            var vcC = new vcCommon();
            var sub = $("<div>").attr("id", "dashboard-chart-wrapper-" + guid).height(h).css("width", "100%").html(vcC.getLoadingIcon());
            $element.html(sub);

            var visual = new vcVisual();
            visual.setShowFullscreen(false);
            visual.setShowHeaderMenu(false);
            visual.addVisualContentByName('dashboard-chart-wrapper-', settings.Ramp.VisualName, guid, getCurrentTimestamp(), h, w, JSON.stringify(settings.Ramp.Param), JSON.stringify(settings.Ramp.SignalParam), 1);


        };

    })(jQuery);